// extracted by mini-css-extract-plugin
export default {"root":"style_root__hmK12","message":"style_message__webCP","icon":"style_icon__Ssdly"};